/** Lower sortOrder is shown first. Equal values fall back to Hebrew name. */
export function compareBySortOrder(
  a: { sortOrder?: number | null; name?: string | null },
  b: { sortOrder?: number | null; name?: string | null },
): number {
  const order = (a.sortOrder ?? 10000) - (b.sortOrder ?? 10000);
  if (order !== 0) return order;
  return (a.name ?? "").localeCompare(b.name ?? "", "he");
}
